import type { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import InstitutionIdentityContext from "src/contexts/data/InstitutionIdentityContext";
import type { GetInstitutionIdentityByIdResponse } from "src/api/Tmd.dtos";
import useInstitutionIdentityById from "src/hooks/data/load/useInstitutionIdentityById";
import type { SWRConfiguration } from "swr";

interface IInstitutionProviderProps extends PropsWithChildren {
    id?: number;
    configuration?: SWRConfiguration<
        GetInstitutionIdentityByIdResponse,
        GetInstitutionIdentityByIdResponse
    >;
}

const InstitutionIdentityProvider: FC<IInstitutionProviderProps> = ({
    children,
    id,
    configuration,
}) => {
    const context = useInstitutionIdentityById(id, configuration);

    return (
        <InstitutionIdentityContext.Provider value={context}>
            {children}
        </InstitutionIdentityContext.Provider>
    );
};

export const RouteInstitutionIdentityProvider: FC<PropsWithChildren> = ({ children }) => {
    const { institutionId } = useParams<{ institutionId: string }>();
    const id = institutionId ? parseInt(institutionId, 10) : undefined;

    return <InstitutionIdentityProvider id={id}>{children}</InstitutionIdentityProvider>;
};

export default InstitutionIdentityProvider;
